import moment from 'moment';
import angular from 'angular';

export default function AddAssessmentDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  loaderService,
  performBusinessImpactAnalysisDialog,
  ssDialogService,
) {
  const vm = this;

  if (vm.assessment.impactAnalysisDueDate) {
    vm.analysisDueDate = moment(vm.assessment.impactAnalysisDueDate);
  } else {
    vm.analysisDueDate = moment().add(30, 'days');
  }

  vm.analysisMinDate = moment().add(1, 'days');

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSelectOwnerName = _handleSelectOwnerName;
  vm.handleAddAssessmentFormSubmit = _handleAddAssessmentFormSubmit;
  vm.someOwnersSelected = _someOwnersSelected;

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.addAssessmentDialog);
  }

  function _saveAssessment() {
    const dfdSave = $q.defer();
    const dfdHideDialog = $q.defer();

    if ($scope.addBCPAddAssessmentForm.$valid) {
      // Set the impact analysis date on assessment object
      vm.assessment.impactAnalysisDueDate = vm.analysisDueDate.format('MM/DD/YYYY');
      loaderService.showViewLoader = true;
      bcpDataService.saveAssessment(vm.assessment).then((assessmentResponse) => {
        const savedAssessment = assessmentResponse.data;
        if (!savedAssessment.assessmentId) {
          alerts.error('An error occurred while saving the Plan.');
          loaderService.showViewLoader = false;
          dfdSave.reject();
        } else if (vm.assessment.assessmentNotifications && vm.assessment.assessmentNotifications.length > 0) {
          bcpDataService.saveNotifications(savedAssessment.assessmentId, vm.assessment.assessmentNotifications)
            .then((response) => {
              const success = response.data;
              if (!success) {
                alerts.error('An error occurred while saving the Plan Notifications.');
                loaderService.showViewLoader = false;
                dfdSave.reject();
              } else {
                _handlePostSaveAssessment(savedAssessment, dfdHideDialog);
              }
            });
        } else {
          _handlePostSaveAssessment(savedAssessment, dfdHideDialog);
        }

        $rootScope.$broadcast('refreshBCPAssessments');
        dfdHideDialog.promise.then(dfdSave.resolve);
      });
    } else {
      dfdSave.reject();
    }

    return dfdSave.promise;
  }

  function _handlePostSaveAssessment(savedAssessment, dfdHideDialog) {
    vm.assessment.assessmentId = savedAssessment.assessmentId;
    alerts.success('The Plan has been saved successfully.');
    loaderService.showViewLoader = false;
    ssDialogService.hide(ssDialogService.dialogs.bcp.addAssessmentDialog)
      .then(dfdHideDialog.resolve);
  }

  function _handleAddAssessmentFormSubmit($event) {
    _saveAssessment().then(() => {
      if (vm.saveType === 'saveAndAnalyze') {
        bcpDataService.getProcessesByUser(vm.assessment.assessmentId).then((getProcessesByUserResponse) => {
          const nonSubmittedProcesses = [];
          angular.forEach(getProcessesByUserResponse.data.result, (process) => {
            if (!process.isManaged
              && (!process.impactAnalysis || (process.impactAnalysis && !process.impactAnalysis.submitted))) {
              nonSubmittedProcesses.push(process);
            }
          });

          ssDialogService.dialogs.bcp.performBusinessImpactAnalysisDialog = ssDialogService.alert(
            performBusinessImpactAnalysisDialog.getOptions($event, {
              assessmentId: vm.assessment.assessmentId,
              processes: nonSubmittedProcesses,
            }),
          );
          ssDialogService.show(ssDialogService.dialogs.bcp.performBusinessImpactAnalysisDialog);
        });
      }
    });
  }

  function _handleSelectOwnerName(owner) {
    owner.isSelected = !owner.isSelected;
  }


  // Validation
  function _someOwnersSelected() {
    if (vm.assessment.assessmentNotifications) {
      return vm.assessment.assessmentNotifications.some(owner => owner.isSelected);
    }
    return false;
  }
}

AddAssessmentDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'loaderService',
  'performBusinessImpactAnalysisDialog',
  'ssDialogService',
];
